"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const redis_1 = require("redis");
const flatten_1 = require("./flatten");
const overrides_1 = require("./overrides");
exports.createHandyClient = (...clientArgs) => {
    const nodeRedis = (typeof clientArgs[0] === "object" && typeof clientArgs[0].scan === "function")
        ? clientArgs[0]
        : redis_1.createClient.apply(null, clientArgs);
    const handyClient = { redis: nodeRedis };
    Object.keys(nodeRedis.__proto__).forEach((key) => {
        const func = nodeRedis[key];
        if (overrides_1.useUnderlyingImpl.has(key)) {
            handyClient[key] = func.bind(nodeRedis);
        }
        else {
            const wrapped = (...args) => new Promise((resolve, reject) => {
                const flattened = flatten_1.flattenDeep(args);
                func.apply(nodeRedis, flattened.concat([(err, data) => err ? reject(err) : resolve(data)]));
            });
            handyClient[key] = wrapped;
        }
    });
    Object.assign(handyClient, overrides_1.additionalFunctions);
    return handyClient;
};
